if (!customElements.get("component-details")) {
  class ComponentDetails extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        tabs: this.querySelectorAll(".component-details__tab"),
        toggleButtons: this.querySelectorAll(".component-details__toggle"),
      };

      this.hasExtraPadding = this.dataset.hasExtraPadding === "true";

      if (this.hasExtraPadding) {
        if (window.matchMedia("(min-width: 750px)").matches) {
          this.additionalPadding = 88;
        } else if (window.matchMedia("(max-width: 749px)").matches) {
          this.additionalPadding = 0;
        }
      } else {
        this.additionalPadding = 0;
      }
    }

    connectedCallback() {
      this.setupEventListeners();
      this.calcHeightOnLoad();
    }

    setupEventListeners() {
      const tabs = Array.from(this.elements.toggleButtons).map((btn) => btn.closest(".component-details__tab"));

      tabs.forEach((tab) => {
        tab.addEventListener("click", () => {
          if (tab.classList.contains("active")) {
            if (window.matchMedia("(max-width: 749px)").matches) {
              tab.classList.remove("active");
            }
          } else {
            tabs.forEach((t) => t.classList.remove("active"));
            tab.classList.add("active");
          }

          if (window.matchMedia("(min-width: 750px)").matches) {
            const tabHeight = tab.querySelector(".component-details__content__wrapper").scrollHeight + this.additionalPadding;
            this.style.minHeight = `${tabHeight}px`;
          }
        });
      });
    }

    calcHeightOnLoad() {
      if (window.matchMedia("(min-width: 750px)").matches) {
        const activeTab = this.querySelector(".component-details__tab.active");
        if (activeTab) {
          const tabHeight = activeTab.querySelector(".component-details__content__wrapper").scrollHeight + this.additionalPadding;
          this.style.minHeight = `${tabHeight}px`;
        }
      }
    }
  }

  customElements.define("component-details", ComponentDetails);
}
